import { ROTAS } from '../../routes-manifest';

function matchesDeclaredRoute(pathname: string): boolean {
  return ROTAS.some(({ path }) => {
    if (path === '*') return false;
    if (path.endsWith('/*')) {
      const base = path.slice(0, -2);
      return pathname === base || pathname.startsWith(`${base}/`);
    }

    const declared = path.split('/');
    const candidate = pathname.split('/');
    if (declared.length !== candidate.length) return false;
    return declared.every((segment, index) => segment.startsWith(':') || segment === candidate[index]);
  });
}

/** Retorno pós-login fechado às rotas relativas declaradas no manifesto. */
export function safeReturnTo(candidate: unknown, fallback = '/'): string {
  if (typeof candidate !== 'string' || candidate.trim() !== candidate) return fallback;
  if (!candidate.startsWith('/') || candidate.startsWith('//') || candidate.includes('\\')) return fallback;

  try {
    const parsed = new URL(candidate, 'https://internal.invalid');
    if (parsed.origin !== 'https://internal.invalid' || !matchesDeclaredRoute(parsed.pathname)) {
      return fallback;
    }
    return candidate;
  } catch {
    return fallback;
  }
}

